import React, { FCC } from 'react';
import posed from 'react-pose';
import { createId } from '../utils/IdGenerator';
import { ICollapseProps } from './types';

const Collapser = posed.div({
  /* tslint:disable:object-literal-sort-keys */
  collapseOpen: {
    applyAtStart: { visibility: 'visible' },
    applyAtEnd: { overflow: 'visible' },
    height: 'auto',
    transition: {
      ease: 'easeInOut',
    },
  },
  collapseClosed: {
    applyAtStart: { overflow: 'hidden' },
    applyAtEnd: { visibility: 'hidden' },
    height: 0,
    transition: {
      ease: 'easeInOut',
    },
  },
  /* tslint:enable:object-literal-sort-keys */
});

export const Collapse: FCC<ICollapseProps> = ({ isOpen, children, ...props }) => {
  const idRef = React.useRef(createId('awesome-collapse'));
  return (
    <Collapser
      key={idRef.current}
      className="collapser"
      aria-expanded={isOpen}
      qa-id={props['qa-id']}
      withParent={false}
      pose={isOpen ? 'collapseOpen' : 'collapseClosed'}
    >
      {children}
    </Collapser>
  );
};

export default Collapse;
